import { FCX, ID, Tooltip } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { useId, useMemo, useState } from "react";
import Popup from "@components/Popup";

const BarPieChart: FCX<{
    values: Array<{
        id: ID;
        color: string;
        barBg: string;
        value: number;
        title: string;
        tooltipContent?: string;
    }>;
}> = ({
    values,
    className,
    testId,
    ...props
}) => {
    const [activeBarId, setActiveBarId] = useState<ID | null>(null);

    const activeBar = useMemo(
        () => values.find((v) => v.id === activeBarId),
        [activeBarId, values],
    );

    const id = useId();

    return (
        <div
            className={cn("BarPieChart", className)}
            data-testid={testId}
            {...props}
        >
            <div className="BarPieChart__bars">
                {values.map((v, index) => (
                    <div
                        key={v.id}
                        data-tooltip-id={`bar-pie-${id}-${v.id}`}
                        className="BarPieChart__bar"
                        style={{
                            flexBasis: `${v.value}%`,
                        }}
                        onMouseEnter={() => setActiveBarId(v.id)}
                        onMouseLeave={() => setActiveBarId(null)}
                        data-testid={`blockChartBar${index}`}
                    >
                        <div
                            className="BarPieChart__bar-color"
                            style={{
                                background: v.barBg,
                            }}
                        />
                    </div>
                ))}
            </div>
            <div className="BarPieChart__legend">
                {values.map((v, index) => (
                    <div
                        key={v.id}
                        className="BarPieChart__legend-item"
                        onMouseEnter={() => setActiveBarId(v.id)}
                        onMouseLeave={() => setActiveBarId(null)}
                        data-testid={`blockChartLegend${index}`}
                    >
                        <div
                            className="BarPieChart__legend-color"
                            style={{ backgroundColor: v.color }}
                            data-testid={`blockChartLegendColor${index}`}
                        />
                        <div data-testid={`textChartLegendTitle${index}`} >
                            {v.title}
                        </div>
                    </div>
                ))}
            </div>
            {activeBarId !== null && (
                <Popup>
                    <Tooltip
                        id={`bar-pie-${id}-${activeBarId}`}
                        className="BarPieChart__tooltip"
                        place="top"
                        isOpen
                        delayHide={100}
                    >
                        <div data-testid={`blockChartTooltip${id}_${activeBarId}`}><b>{activeBar?.value}% {activeBar?.title}</b></div>
                        {activeBar?.tooltipContent && <div data-testid={`blockChartTooltipContent${id}_${activeBarId}`}>{activeBar?.tooltipContent}</div>}
                    </Tooltip>
                </Popup>
            )}
        </div>
    );
};

export default BarPieChart;